import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PublicCatalogSharePage from 'modules/PublicCatalog/pages/PublicCatalogSharePage';
import { PUBLIC_PORTAL_PAGE_ROUTE } from './publicPortalRoutes';

// Routes for the public CBAM Portal. Mounted by _app.jsx when the URL matches
// /public/cbam-portal/* — completely outside the SignedIn auth gate. The
// :slug is operator-configurable (e.g. aurora-steel-works) or auto-generated,
// and the page is password-gated inside PublicCatalogSharePage.
const PublicCatalogRoutes = () => (
  <Switch>
    <Route
      path={PUBLIC_PORTAL_PAGE_ROUTE}
      exact
      component={PublicCatalogSharePage}
    />
  </Switch>
);

export default PublicCatalogRoutes;
